import { render, staticRenderFns } from "./soundRecordingIcon.vue?vue&type=template&id=26fd7d09&scoped=true"
import script from "./soundRecordingIcon.vue?vue&type=script&lang=js"
export * from "./soundRecordingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fd7d09",
  null
  
)

export default component.exports